import React from 'react';
import { Link } from 'react-router-dom';
import {
  Clock,
  ArrowLeft,
  Home,
  Sparkles,
  Star
} from 'lucide-react';

const ComingSoon = () => {
  return (
    <main id="main-content" className="bg-white pt-20">
      {/* Hero Section */}
      <section className="min-h-screen flex items-center justify-center hero-gradient text-white">
        <div className="container-padding text-center">
          <div className="max-w-4xl mx-auto">
            {/* Animated Icon */}
            <div className="relative inline-block mb-12">
              <div className="w-32 h-32 bg-white/10 backdrop-blur-md rounded-full flex items-center justify-center border border-white/20">
                <Clock className="h-16 w-16 text-gold-400 animate-pulse" />
              </div>
              <Sparkles className="absolute -top-2 -right-2 h-8 w-8 text-gold-400 animate-pulse" />
              <Star className="absolute -bottom-2 -left-2 h-6 w-6 text-gold-300 animate-pulse" />
            </div>

            {/* Main Heading */}
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-light mb-8 leading-tight">
              <span className="block font-extralight text-white/90">Something Amazing</span>
              <span className="block font-medium">Coming Soon</span>
            </h1>

            <div className="w-20 h-px bg-gold-400 mx-auto mb-8"></div>

            {/* Description */}
            <p className="text-xl md:text-2xl text-white/85 mb-12 font-light max-w-3xl mx-auto leading-relaxed">
              We're working hard to bring you this page. Check back soon for exciting updates and new features!
            </p>

            {/* Feature Highlights */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16 max-w-4xl mx-auto">
              <div className="bg-white/10 backdrop-blur-md rounded-xl p-6 border border-white/20">
                <div className="w-12 h-12 bg-primary-50 rounded-lg flex items-center justify-center mx-auto mb-4">
                  <Sparkles className="h-6 w-6 text-primary-700" />
                </div>
                <h2 className="text-lg font-medium mb-2">Enhanced Features</h2>
                <p className="text-white/75 text-sm font-light">
                  New functionality to better serve our community
                </p>
              </div>

              <div className="bg-white/10 backdrop-blur-md rounded-xl p-6 border border-white/20">
                <div className="w-12 h-12 bg-gold-50 rounded-lg flex items-center justify-center mx-auto mb-4">
                  <Star className="h-6 w-6 text-gold-700" />
                </div>
                <h2 className="text-lg font-medium mb-2">Better Experience</h2>
                <p className="text-white/75 text-sm font-light">
                  Improved design and user-friendly interface
                </p>
              </div>

              <div className="bg-white/10 backdrop-blur-md rounded-xl p-6 border border-white/20">
                <div className="w-12 h-12 bg-primary-50 rounded-lg flex items-center justify-center mx-auto mb-4">
                  <Home className="h-6 w-6 text-primary-700" />
                </div>
                <h2 className="text-lg font-medium mb-2">More Resources</h2>
                <p className="text-white/75 text-sm font-light">
                  Additional tools and information for families
                </p>
              </div>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-6 justify-center">
              <Link
                to="/"
                className="bg-white text-primary-900 hover:bg-white/95 font-medium px-10 py-4 rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl flex items-center justify-center space-x-3"
              >
                <Home className="h-5 w-5" />
                <span>Return Home</span>
              </Link>
              <Link
                to="/about"
                className="btn-elegant flex items-center justify-center space-x-3"
              >
                <ArrowLeft className="h-5 w-5" />
                <span>Go Back</span>
              </Link>
            </div>

            {/* Additional Info */}
            <div className="mt-16 pt-8 border-t border-white/20">
              <p className="text-white/60 text-sm font-light">
                Have questions? Contact us at{' '}
                <a href="mailto:info@tagscholars.edu" className="text-gold-400 hover:text-gold-300 underline">
                  info@tagscholars.edu
                </a>
              </p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default ComingSoon;
